module.exports = __webpack_public_path__ + "static/media/19ESCAP44.d2819ab4.jpg";